export function setupChunkErrorHandler() {
  window.addEventListener('error', (event) => {
    // Check if it's a chunk loading error
    if (
      event.message.includes('Loading chunk') ||
      event.message.includes('Failed to fetch dynamically imported module')
    ) {
      console.error('Chunk loading failed, reloading page...', event);
      // Clear service worker cache and reload
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => registration.unregister());
        });
      }
      window.location.reload();
    }
  });
}
